(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bucci-product-info"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBucciSticky() {
    var bar = document.querySelector('.bucci-sticky-atc');
    if (!bar) return;

    // Observe a STABLE element. Prestige replaces the ATC button node on every
    // variant/size change, so we must never cache the button — anchor the
    // visibility observer on the product form, which is not replaced.
    var anchor = document.querySelector('.ProductForm') ||
                 document.querySelector('form[action*="/cart/add"]');
    if (!anchor) { bar.parentNode && bar.parentNode.removeChild(bar); return; }

    var proxy = bar.querySelector('.bucci-sticky-atc__btn');
    if (proxy) {
      proxy.addEventListener('click', function (e) {
        e.preventDefault();
        // Re-query the real ATC button FRESH on each tap (it may have been
        // replaced by a variant change). Clicking it runs Prestige's native
        // add-to-cart + drawer-open sequence — single tap, no double-click.
        var btn = document.querySelector('.ProductForm__AddToCart');
        if (btn) { btn.click(); }
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      io.observe(anchor);
    }
  }

  if (document.readyState !== 'loading') {
    initBucciSticky();
  } else {
    document.addEventListener('DOMContentLoaded', initBucciSticky);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    
/* Buccisimo custom: collection filter bar (client-side, derived from product data) */
(function () {
  function initBucciCollFilter() {
    var root = document.querySelector('[data-bucci-collfilter]');
    if (!root) return;
    var section = root.closest('[data-section-type="collection"]') || document;
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-bucci-card]'));
    var countEl = root.querySelector('[data-bucci-count]');
    var state = { metal: 'all', type: 'all', price: 'all' };

    function priceMatch(val, cents) {
      if (val === 'all') return true;
      var parts = val.split('-');
      var min = parseInt(parts[0], 10) || 0;
      var max = (parts[1] === '' || parts[1] === undefined) ? Infinity : parseInt(parts[1], 10);
      return cents >= min && cents < max;
    }

    function apply() {
      var shown = 0;
      cards.forEach(function (card) {
        var ok = (state.metal === 'all' || card.getAttribute('data-bucci-metal') === state.metal)
          && (state.type === 'all' || card.getAttribute('data-bucci-type') === state.type)
          && priceMatch(state.price, parseInt(card.getAttribute('data-bucci-price'), 10) || 0);
        card.style.display = ok ? '' : 'none';
        if (ok) { shown++; }
      });
      if (countEl) { countEl.textContent = shown + (shown === 1 ? ' piece' : ' pieces'); }
    }

    root.querySelectorAll('.bucci-collfilter__pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = pill.getAttribute('data-filter');
        state[group] = pill.getAttribute('data-value');
        root.querySelectorAll('.bucci-collfilter__pill[data-filter="' + group + '"]').forEach(function (p) {
          p.classList.toggle('is-active', p === pill);
        });
        apply();
      });
    });

    var sortSel = root.querySelector('[data-bucci-sort]');
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        var url = root.getAttribute('data-collection-url') || window.location.pathname;
        window.location.href = url + '?sort_by=' + encodeURIComponent(sortSel.value);
      });
    }

    var filterToggle = root.querySelector('[data-bucci-filter-toggle]');
    if (filterToggle) {
      filterToggle.addEventListener('click', function () {
        var open = root.classList.toggle('is-open');
        filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    apply();
  }

  if (document.readyState !== 'loading') { initBucciCollFilter(); }
  else { document.addEventListener('DOMContentLoaded', initBucciCollFilter); }
})();

  } catch(e) { console.error(e); }
})();
})();
